import React, { useState } from 'react';
import axios from '../../api/axios';
import styles from './styles.module.css';
import { useAuth } from '../../context/AuthProvider';
import Modal from 'react-modal';

function DeleteProblemModal({closeModal,selectedProblem}) {
  Modal.setAppElement('#root');
  const {token} = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("selected Problem",selectedProblem);
      const data = await axios.delete('/problems/delete/'+selectedProblem.title,{
        headers:{"Authorization":"Bearer "+token,email:sessionStorage.getItem("userId")}
      });

      if(data)
      {
        closeModal(false);
      window.location.reload();
      }

      // Close the modal after successful submission
      closeModal(false);
      window.location.reload();
    } catch (error) {
      console.error('Error submitting the problem:', error);
    }
  };

  return (
    <Modal
    isOpen={true} // You can control the modal's visibility with a state
    onRequestClose={closeModal}
    contentLabel="Delete Problem Modal"
  >
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.titleCloseBtn}>
          <button onClick={() => closeModal(false)}> X </button>
        </div>
        <div className={styles.title}>
          <h2>Delete Problem </h2>
        </div>
        <div className={styles.body}>
          <form onSubmit={handleSubmit}>
            {/* Add form fields */}
            <label>Title:</label>
            <input
              type="text"
              name="title"
              readOnly
              placeholder="Problem Title"
              value={selectedProblem.title}
            />
            <button type="submit">Delete</button>
            <button type="reset" onClick={()=>closeModal(false)}>Cancel</button>
          </form>
        </div>
      </div>
    </div>
    </Modal>
  );
}

export default DeleteProblemModal;